import Table from './component'

export default Table
